import { camelToDash as a } from "./atoms-v2966.js";
const t = "framerAppearId", e = "data-" + a(t);
export {
  e as optimizedAppearDataAttribute,
  t as optimizedAppearDataId
};
